import layout from '@/views/layout/layout.vue'
const orderList = r => require.ensure([], () => r(require('@/views/products/order/list.vue')), 'group-products-order')

const productsOrder = [
  {
    path: '/products/order',
    name: 'products-order',
    component: layout,
    redirect: '/products/order/list',
    children: [
      {
        path: 'list',
        name: 'products-order-list',
        component: orderList,
        meta: {
          displayName: '订单管理',
          requireAuth: true
        }
      }
    ]
  }
]

export default productsOrder



// WEBPACK FOOTER //
// ./src/router/products/order.js